import { RootState } from "../../../store";
import { dimensionsSliceSelector } from "../dimensionsSliceSelector";

export const dimensionIdSelector = (state: RootState) => {
  const slice = dimensionsSliceSelector(state);

  return slice.dimensionId;
};
